import { render, staticRenderFns } from "./YieldPage.vue?vue&type=template&id=4b476f06&scoped=true"
import script from "./YieldPage.vue?vue&type=script&lang=js"
export * from "./YieldPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b476f06",
  null
  
)

export default component.exports